import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User, UserRole } from '../../pages/customers/customers.type';

/**
 * Keeps entity owners out of the staff-only pages this guard is placed on
 * (tasks board, services, employees, customers, commissions, embassy…).
 *
 * The previous version used `tap`, whose return value is ignored, so the guard
 * let every logged-in user through — including entity owners typing the URL.
 * Staff roles are unaffected; the API still enforces permissions server-side.
 */
@Injectable()
export class CanActivateForEntityGuard implements CanActivate, CanLoad {
  constructor(
    private authService: NbAuthService,
    private router: Router
  ) {}

  process(): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated().pipe(
      map((authenticated) => {
        if (!authenticated) return this.router.parseUrl('/auth/login');

        const user =
          localStorage.getItem('user') && (JSON.parse(localStorage.getItem('user')) as User);
        if (user?.role === UserRole.ENTITY_OWNER) return this.router.parseUrl('/pages/home');

        return true;
      })
    );
  }

  canLoad() {
    return this.process();
  }

  canActivate() {
    return this.process();
  }
}
